import { useEffect } from "react";

const RedirectHandler = () => {
  useEffect(() => {
    const currentHost = window.location.hostname;
 
    if (currentHost.includes("azurewebsites.net")) {
      const newUrl = `https://agriintel.capitalfarmcredit.ai${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.replace(newUrl); // Redirect to the correct domain
    }

  }, []);

  return null; // No UI, just redirects
};

export default RedirectHandler;
